import React from 'react'
import PropTypes from 'prop-types'

const Alert = (props) => (
  <div className={`alert alert-${props.type} ${props.className}`} role="alert" style={props.style}>
    {props.children}
  </div>
)

Alert.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.string,
  className: PropTypes.string,
}

export default Alert



// WEBPACK FOOTER //
// ./client/components/Alert.js